import React from 'react';
import './StatTile.css';

interface StatTileProps {
  value: React.ReactNode;
  label: string;
}

const StatTile: React.FC<StatTileProps> = ({ value, label }) => (
  <div className="stat-tile">
    <div className="stat-tile-value tabular">{value}</div>
    <div className="stat-tile-label" data-testid="stat-label">
      {label}
    </div>
  </div>
);

export default StatTile;
